/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { expanded: true }, tokens: { icon: PaletteIconCaretUp } }
  ],
  tokens: {
    collapseDuration: 250,
    contentPaddingBottom: 0,
    contentPaddingLeft: 0,
    contentPaddingRight: 0,
    contentPaddingTop: 0,
    expandDuration: 300,
    icon: PaletteIconCaretDown,
    iconColor: '#2b8000',
    iconGap: 8,
    iconPosition: 'right',
    iconSize: 24,
    justifyContent: 'space-between',
    verticalAlign: 'middle'
  }
}
export default theme
